exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wave[data-v-77dabbea] {\n    stroke-dasharray: 50px 10px;\n    stroke-dashoffset: -30px;\n    transition: all 0.5s;\n}\nsvg:hover .wave[data-v-77dabbea],\nsvg:focus .wave[data-v-77dabbea],\nsvg:active .wave[data-v-77dabbea] {\n    cursor: pointer;\n    stroke-dashoffset: 0;\n}\n\n", ""]);

// exports
